<div class="details-panel-wrapper">
  <div *ngFor="let column of [].constructor(columns); let x = index" class="column-wrapper">
    <ul class="list-wrapper">
      <li *ngFor="let item of items; let i = index" class="item-wrapper">
        <ng-container *ngIf="i >= x*rows && (x+1)*rows > i">
          <p class="item-label">{{item.label}}</p>
          <p class="item-separator">:</p>
          <p class="item-value">{{item.value}}</p>
        </ng-container>
      </li>
    </ul>
  </div>
</div>